import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { legacy_createStore as createStore } from "redux";
import { Provider } from "react-redux";

const initState = {
  userDetails: undefined,
  bloodPResults: undefined,
  invoices: undefined,
  hafnayot: undefined,
  weightResults: undefined,
  ecgsResults: undefined,
  activitiesResults: undefined,
  cardioRResults: undefined,
  patients: undefined,
  selectedPatient: undefined,
  darkMode: localStorage.getItem("darkMode") === "true",
};
const reducer = (state = initState, action) => {
  switch (action.type) {
    case "UPDATE_USER_DETAILS":
      state = { ...state, userDetails: action.payload };
      break;
    case "UPDATE_BLOODP_RESULTS":
      state = { ...state, bloodPResults: action.payload };
      break;
    case "TOGGLE_DARK_MODE":
      localStorage.setItem("darkMode", action.payload);
      return { ...state, darkMode: action.payload };
    case "UPDATE_INVOICES":
      state = { ...state, invoices: action.payload };
      break;
    case "UPDATE_HAFNAYOT":
      state = { ...state, hafnayot: action.payload };
      break;
    case "UPDATE_WEIGHT_RESULTS":
      state = { ...state, weightResults: action.payload };
      break;
    case "UPDATE_ECG_RESULTS":
      state = { ...state, ecgsResults: action.payload };
      break;
    case "UPDATE_ACTIVITIES_RESULTS":
      state = { ...state, activitiesResults: action.payload };
      break;
    case "UPDATE_CARDIOR_RESULTS":
      state = { ...state, cardioRResults: action.payload };
      break;
    case "UPDATE_PATIENTS":
      state = { ...state, patients: action.payload };
      break;
    case "UPDATE_SELECTED_PATIENT":
      state = { ...state, selectedPatient: action.payload };
      break;
    case "LOGOUT":
      state = {
        ...state,
        userDetails: undefined,
        bloodPResults: undefined,
        weightResults: undefined,
        ecgsResults: undefined,
        activitiesResults: undefined,
        cardioRResults: undefined,
        patients: undefined,
        selectedPatient: undefined,
      };
      break;
  }
  return state;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
const store = createStore(reducer);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
